import { getScopedPath } from 'owa-url';
import getRootVdirName from 'owa-url/lib/getRootVdirName';
import { addBottleneck } from 'owa-performance';
import { logUsage } from 'owa-analytics';
import { getHostLocation } from 'owa-url/lib/hostLocation';

export function testIfRouteExists(): boolean {
    const pathname = getHostLocation()?.pathname;
    const scopedPath = getScopedPath(getRootVdirName() || 'mail');
    const routeExists =
        scopedPath != pathname &&
        scopedPath + '/' != pathname &&
        scopedPath + '/inbox' != pathname &&
        scopedPath + '/inbox/' != pathname;
    addBottleneck('r_e', routeExists ? 't' : 'f');
    if (routeExists) {
        logUsage('RouteExists', {
            scope: scopedPath,
            path: pathname,
        });
    }
    return routeExists;
}
